module.exports = __webpack_public_path__ + "static/media/01_A5_01.7d8e6a45.png";